
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cars/[slug]/[model]",
      function () {
        return require("private-next-pages/cars/[slug]/[model].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cars/[slug]/[model]"])
      });
    }
  